import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { EstadoAcuerdo } from '../estado-acuerdo.model';
import { SecurityService } from '../../security/security.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material';
import { Acuerdo } from '../acuerdo.model';
import { SnackService } from '../../shared-services/snack.service';

@Component({
  selector: 'app-acuerdo-table',
  templateUrl: './acuerdo-table.component.html',
  styleUrls: ['./acuerdo-table.component.scss']
})
export class AcuerdoTableComponent implements OnInit {

  @Input() acuerdosList: Acuerdo[];
  public EstadoAcuerdo = new EstadoAcuerdo();
  constructor(
    public router: Router,
    public securityService: SecurityService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private snackService: SnackService,
  ) {
    this.matIconRegistry.addSvgIcon(
      'pend_revision_act_doc',
      this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/sharp-notification_important.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'pend_aprobacion_email',
      this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/sharp-unsubscribe.svg')
    );
  }

  ngOnInit() {
  }

  detallesAcuerdo(id: number) {
    this.router.navigate(['/acuerdos/detalles', id]);
  }

  async verPedidos(acuerdo) {
    this.snackService.spinner(true);
    await this.router.navigate(['/acuerdos/ver-pedidos/' + acuerdo.id]);
    this.snackService.spinner(false);
  }

  async verProductosPedidos(acuerdo) {
    this.snackService.spinner(true);
    await this.router.navigate(['/acuerdos/ver-productos-acuerdo/' + acuerdo.id]);
    this.snackService.spinner(false);
  }

  async replicar(acuerdo) {
    this.snackService.spinner(true);
    await this.router.navigate(['/acuerdos/replicar/' + acuerdo.id]);
    this.snackService.spinner(false);
  }

}



// WEBPACK FOOTER //
// ./src/app/acuerdo/acuerdo-table/acuerdo-table.component.ts